import { DATA } from '@/data'
import { Link } from 'react-router-dom'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'

const navLinks = [
    { label: 'home',     to: '/' },
    { label: 'projects', to: '/projects' },
    { label: 'about',    to: '/about' },
    { label: 'blog',     to: '/blog' },
    { label: 'contact',  to: '/contact' },
]

const socials = [
    {
        label: 'GitHub',
        href:  DATA.contact.social.GitHub.url,
        Icon:  FaGithub,
    },
    {
        label: 'LinkedIn',
        href:  DATA.contact.social.LinkedIn.url,
        Icon:  FaLinkedin,
    },
    {
        label: 'Email',
        href:  DATA.contact.social.Email.url,
        Icon:  MdEmail,
    },
]

const year = new Date().getFullYear()

export default function Footer() {
    return (
        <footer className="border-t border-border bg-[#050505] font-mono">

            {/* Main footer body */}
            <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">

                {/* Brand block */}
                <div className="space-y-5">
                    <div className="flex items-center gap-1 text-sm">
                        <span className="text-primary font-bold">rapheal</span>
                        <span className="text-[#444]">@</span>
                        <span className="text-[#666]">portfolio</span>
                        <span className="text-[#444]">:~$</span>
                    </div>

                    {/* Social icons — match Contact page palette */}
                    <div className="flex items-center gap-4">
                        {socials.map(({ label, href, Icon }) => (
                            <a
                                key={label}
                                href={href}
                                aria-label={label}
                                target={href.startsWith('http') ? '_blank' : undefined}
                                rel="noopener noreferrer"
                                className="group flex items-center justify-center w-8 h-8 border border-[#1a1a1a]
                                           rounded-sm text-[#555] hover:text-primary hover:border-primary/30
                                           transition-all duration-150"
                            >
                                <Icon size={15} />
                            </a>
                        ))}
                    </div>
                </div>

                {/* Navigation */}
                <div>
                    <p className="text-xs text-primary mb-4 font-mono">$ ls pages</p>
                    <ul className="space-y-2">
                        {navLinks.map(({ label, to }) => (
                            <li key={label}>
                                <Link
                                    to={to}
                                    className="text-xs text-[#555] hover:text-foreground font-mono transition-colors duration-150
                                               flex items-center gap-2 group"
                                >
                                    <span className="text-[#333] group-hover:text-primary transition-colors">&gt;</span>
                                    {label}/
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact quick block */}
                <div>
                    <p className="text-xs text-primary mb-4 font-mono">$ contact --quick</p>
                    <div className="space-y-2 text-xs text-[#555] font-mono">
                        <p>raphealasomanikwabena@gmail.com</p>
                        <p>github.com/Rapheal-Kwabena</p>
                        <p>linkedin.com/in/younggem</p>
                        <a
                            href="/Rapheal-Kwabena-Resume.pdf"
                            download
                            className="inline-flex items-center gap-1 mt-3 text-xs font-mono border border-border
                                       text-[#666] hover:text-primary hover:border-primary/40 px-3 py-1.5 rounded-sm
                                       transition-all duration-150"
                        >
                            [ resume.pdf ]
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom status bar */}
            <div className="border-t border-border bg-[#030303] px-6 py-2">
                <div className="max-w-6xl mx-auto flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-4 text-[10px] font-mono text-[#444] flex-wrap">
                        <span className="flex items-center gap-1.5">
                            <span className="status-dot-online" />
                            Connection: <span className="text-primary ml-1">ONLINE</span>
                        </span>
                        <span className="hidden sm:block">Security: <span className="text-primary">AUTHORIZED</span></span>
                        <span className="hidden sm:block">Session: <span className="text-primary">ACTIVE</span></span>
                        <span className="hidden md:block">Build: <span className="text-primary">PRODUCTION</span></span>
                        <span className="hidden md:block">v2.6.0</span>
                        <span className="hidden lg:block">Latency: <span className="text-primary">12ms</span></span>
                        <span className="hidden lg:block">Node: <span className="text-primary">CONNECTED</span></span>
                        <span className="hidden lg:block">Health: <span className="text-primary">100%</span></span>
                    </div>
                    <p className="text-[10px] font-mono text-[#333]">
                        © {year} Rapheal Kwabena Asomani Gadoh
                    </p>
                </div>
            </div>

        </footer>
    )
}
